module.exports = __webpack_public_path__ + "static/media/airbrake-mx-poster.bf69dc20.png";


//////////////////
// WEBPACK FOOTER
// ./src/screens/switchlock/airbrake-mx-poster.png
// module id = 3498
// module chunks = 0